const RequestTypeFilterButton = ({
  label,
  recordCount,
  isActive,
  clickHanler,
  isComingFromDocuments,
}) => {
  return (
    <>
      <span
        className={` ${isActive ? 'active-claim' : ''}`}
        onClick={() => {
          clickHanler(label);
        }}
        title={label}
      >
        {isComingFromDocuments && isComingFromDocuments
          ? label.length > 26
            ? label.substring(0, 26) + '...'
            : label
          : label.length > 30
          ? label.substring(0, 30) + '...'
          : label}
        &nbsp;{recordCount && `(${recordCount})`}
      </span>
    </>
  );
};
export default RequestTypeFilterButton;
